import { BoatBySlugQueryResult } from '@app/sanity.types';
import { FileIcon } from '@marine/files';
import { List, Tag, Typography } from 'antd';
import { ChevronDown } from 'lucide-react';
import { FC, useCallback } from 'react';
import styles from './BoatDocuments.module.scss';

export interface BoatDocumentsProps {
  documents?: BoatBySlugQueryResult['documents'];
}

const BoatDocuments: FC<BoatDocumentsProps> = ({ documents }) => {
  const getFileSize = useCallback((size?: number): string | undefined => {
    if (size) {
      return (size / 1000000).toFixed(2) + 'MB';
    }
  }, []);

  return (
    <div className={styles.boatDocumentsWrapper}>
      <List
        bordered
        dataSource={documents}
        renderItem={(item) => (
          <List.Item>
            <div className={styles.item}>
              <FileIcon ext={item.file.asset.extension} />
              <div className={styles.content}>
                <div className={styles.text}>
                  <Typography.Text>
                    <strong>{item.file.asset.originalFilename}</strong>
                  </Typography.Text>
                  {Array.isArray(item.tags) && item.tags.length && (
                    <ul className={styles.tags}>
                      {item.tags.map((item) => (
                        <li key={item}>
                          <Tag color="geekblue">{item}</Tag>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className={styles.action}>
                  <span style={{ marginRight: 16 }}>{getFileSize(item.file.asset.size)}</span>
                  {!!item.file.asset.url && (
                    <a
                      href={item.file.asset.url}
                      target="_blank"
                      rel="noreferrer"
                      download={item.file.asset.url}
                      className="ant-btn ant-btn-default"
                    >
                      <ChevronDown /> Download
                    </a>
                  )}
                </div>
              </div>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export { BoatDocuments };
